module.exports = __webpack_public_path__ + "img/our-customers2.ecb9ae80.jpg";